// src/hooks/useUser.js
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { currentToken } from "../redux/features/userSlice";
import { decodeToken, getUserRole, getUserId, isTokenExpired, isAdmin, isCustomer } from "../Utiles/jwtUtils";

const useUser = () => {
  const token = useSelector(currentToken);

  return useMemo(() => {
    if (!token) return { token: null, userId: null, role: null, expired: true, isAdmin: false, isCustomer: false };

    const decoded = decodeToken(token);
    return {
      token,
      userId: getUserId(token),
      role: getUserRole(token),
      expired: isTokenExpired(token),
      isAdmin: isAdmin(token),
      isCustomer: isCustomer(token),
      decoded,
    };
  }, [token]);
};

export default useUser;
